import { USER_INFO } from "src/common/constants";
import { UserInfoClaimsI } from "src/types/User";

export const USER_INFO_SET = `${USER_INFO}_SET` as const;
export const USER_INFO_CLEAR = `${USER_INFO}_CLEAR` as const;
export const USER_INFO_FAILED = `${USER_INFO}_FAILED` as const;

interface UserInfoSetActionI {
  type: typeof USER_INFO_SET;
  payload: UserInfoClaimsI;
}

interface UserInfoClearActionI {
  type: typeof USER_INFO_CLEAR;
}

interface UserInfoFailedActionI {
  type: typeof USER_INFO_FAILED;
  error: Error;
}

export type UserInfoActionI =
  | UserInfoSetActionI
  | UserInfoClearActionI
  | UserInfoFailedActionI;

export const setUserInfo = (payload: UserInfoClaimsI): UserInfoActionI => ({
  type: USER_INFO_SET,
  payload,
});

export const clearUserInfo = (): UserInfoActionI => ({
  type: USER_INFO_CLEAR,
});

export const setUserInfoFailed = (error: Error): UserInfoActionI => ({
  type: USER_INFO_FAILED,
  error,
});
